import { Checkbox } from "shared";
import {
    ComponentTypes,
    ITemplateComponent,
    ITemplateYandexComponent
} from "entities/template";
import React from "react";
import { useComponentsTranslations } from "../../../../lib/i18n";
import { FieldList } from "../../form_fields/field_list/field_list";
import { VisibilityField } from "../../form_fields/visibility_field/visibility_field";
import { LegalCompanyList } from "../../form_fields/legal_company_list/legal_company_list";
import { TooltipField } from "../../form_fields/tooltip_field/tooltip_field";
import { LabelField } from "../../form_fields/label_field/label_field";
import styles from "./component_form_legal_yandex.module.scss";


interface IComponentFormLegalYandexProps {
    component: ITemplateYandexComponent;
    enLanguageEnabled: boolean;
    componentList: ITemplateComponent[];
    triggerValidate: number;
    onChange: (component: ITemplateComponent) => void;
}

export const ComponentFormLegalYandex: React.FC<IComponentFormLegalYandexProps> = React.memo(({
                                                                                               component,
                                                                                               triggerValidate,
                                                                                               enLanguageEnabled,
                                                                                               componentList,
                                                                                               onChange
                                                                                           }) => {
    const t = useComponentsTranslations();

    const onFieldChange = (value: Partial<ITemplateYandexComponent>) => {
        onChange({
            ...component,
            ...value
        })
    }

    return <div className={styles.container}>
        <LabelField component={component}
                    enLanguageEnabled={enLanguageEnabled}
                    title={t("formLabel")}
                    name="label-dynamic-input"
                    onChange={onFieldChange}/>
        <LegalCompanyList
            component={component}
            onChange={onFieldChange}/>
        <FieldList
            type={ComponentTypes.legalYandex}
            suffix={component.suffix}
            fieldList={component.fieldsList}
            required={true}
            triggerValidate={triggerValidate}
            showSubLabel={false}
            onChange={onFieldChange}/>
        <VisibilityField
            component={component}
            componentList={componentList}
            onChange={onFieldChange}/>
        <TooltipField
            component={component}
            enLanguageEnabled={enLanguageEnabled}
            onChange={onFieldChange}
        />
        <div className={styles.checkboxGroup}>
            <Checkbox
                label={t("requiredField")}
                size="m"
                onChange={() => onFieldChange({ required: typeof component.required === "boolean" ? !component.required : false })}
                checked={typeof component.required === "boolean" ? component.required : true}
            />
            <Checkbox
                label={t("readonlyField")}
                size="m"
                onChange={() => onFieldChange({ readonly: !component.readonly })}
                checked={component.readonly}
            />
        </div>
    </div>;
});
